import { RequestKind, boolean } from '@sb/library/base';
import { DisplayItemCollection, MileageCashRateUpdateItem, MileageDeleteOptions, MileageDisplayItem, MileageInputItem, MileageSearchOptions, MileageSummaryDisplayItem, MileageSummarySearchOptions, MileageUpdateItem } from '@sb/library/data-models';
import { ApiRoute } from '../api-route';

export namespace MileageRoutes {
    export const Get = ApiRoute.Define({
        URL: (id: string) => `mileages/${id}`,
        Kind: RequestKind.Get,
        ResultType: MileageDisplayItem
    });

    export const Add = ApiRoute.Define({
        URL: `mileages`,
        Kind: RequestKind.Post,
        BodyType: MileageInputItem,
        ResultType: Array<string>
    });

    export const Delete = ApiRoute.Define({
        URL: (id: string) => `mileages/${id}`,
        Kind: RequestKind.Delete,
        BodyType: MileageDeleteOptions,
        ResultType: boolean
    });

    export const GetMonthRecord = ApiRoute.Define({
        URL: (teacherID: string) => `months/mileages/${teacherID}`,
        Kind: RequestKind.Get,
        ResultType: Array<string>
    });

    export const GetYearRecord = ApiRoute.Define({
        URL: (id: string) => `years/mileages/${id}`,
        Kind: RequestKind.Get,
        ResultType: Array<number>
    });

    export const Search = ApiRoute.Define({
        URL: `search/mileages`,
        Kind: RequestKind.Post,
        BodyType: MileageSearchOptions,
        PagingAllowed: true,
        ResultType: DisplayItemCollection<MileageDisplayItem>
    });

    export const Summary = ApiRoute.Define({
        URL: `summary/mileages/`,
        Kind: RequestKind.Post,
        PagingAllowed: true,
        BodyType: MileageSummarySearchOptions,
        ResultType: DisplayItemCollection<MileageSummaryDisplayItem>
    });

    export const Update = ApiRoute.Define({
        URL: (id: string) => `mileages/${id}`,
        Kind: RequestKind.Put,
        BodyType: MileageUpdateItem,
        ResultType: boolean
    });

    export const UpdateCashRate = ApiRoute.Define({
        URL: `mileages`,
        Kind: RequestKind.Patch,
        ResultType: boolean,
        BodyType: MileageCashRateUpdateItem,
        Cancellable: false
    });
}
